"use client";

import Link from "next/link";
import { usePortalTranslations } from "../i18n/client";
import styles from "./PortalSurface.module.css";

export function PortalDirectoryBackLink() {
  const t = usePortalTranslations();
  return <Link className={styles.directoryBackLink} href="/" prefetch={false}>
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M19 12H5m6-6-6 6 6 6" /></svg>
    {t("portal.navigation.allPortals")}
  </Link>;
}
